import {
  BooleanOption,
  BooleanQuestion,
  Question as IQuestion,
  Quiz as IQuiz,
  MultipleChoiceOption,
  MultipleChoiceQuestion,
} from "@/api";

export type Quiz = IQuiz;

export const enum QuizStatus {
  NotStarted = "not-started",
  BelowPassingScore = "below-passing-score",
  Passed = "passed",
}

export type Attempt = {
  score: number;
  completedAt: string;
};

export const enum QuestionStatus {
  NotStarted = "not-started",
  Correct = "correct",
  Incorrect = "incorrect",
}

export type Question = IQuestion;
export type Option = MultipleChoiceOption | BooleanOption;

export type QuestionDifficulty = "easy" | "medium" | "hard";

export function isMultipleChoiceQuestion(question: Question): question is MultipleChoiceQuestion {
  return question.type === "multiple-choice";
}

export function isBooleanQuestion(question: Question): question is BooleanQuestion {
  return question.type === "boolean";
}
